<template>
  <transition>
    <!-- <div ref="dragIcon" class="dragIcon" @mousedown="handleTouchStart" @mouseup.stop="handleTouchEnd" @mouseleave="handleTouchLeave" -->
    <div ref="dragIcon" class="dragIcon" v-if="isShow" @click="$parent.largeHalf();">
      <i class="el-icon-copy-document"></i>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    itemWidth: {
        type: Number,
        default: 50
    },
    itemHeight: {
        type: Number,
        default: 50
    }
  },
  data() {
    return {
      left: 0,
      top: 0,
      startToMove: false,
      isShow: true,
      timer: null,
      currentTop: null,
      clientW: document.documentElement.clientWidth,
      clientH: document.documentElement.clientHeight,
      oldLeft: null,
      oldTop: null
    }
  },
  created () {
    // this.left = (this.clientW - (this.itemWidth+2))
    // this.top = ((this.clientH-100) - this.itemHeight/2)
  },
  mounted() {
    // this.bindScrollEvent()
  },
  beforeDestroy() {
    // 销毁一些全局的的事件
    this.removeScrollEvent()
  },
  methods: {
    handleTouchStart() {
      let that = this
      this.oldLeft = this.left
      this.oldTop = this.top
      this.startToMove = true
      this.$refs.dragIcon.style.transition = "none"
      document.onmousemove=function (ev) {
        that.handleTouchMove(ev)
      }
    },
    handleTouchMove(e) {
      const clientX = e.clientX
      const clientY = e.clientY
      const isInScreen = clientX <= this.clientW && clientX >= 0 && clientY <= this.clientH && clientY >=0
      if(this.startToMove) {
          if(isInScreen) {
              this.left = clientX - this.itemWidth/2
              this.top = clientY - this.itemHeight/2
          }
      }
    },
    handleTouchLeave(){
      if(this.oldLeft!=this.left && this.oldTop!=this.top){
        if(this.startToMove){
          this.$messageWarning('移动过快')
        }
      }
    },
    handleTouchEnd() {
      if(this.oldLeft==this.left && this.oldTop==this.top){
        this.$parent.largeHalf();
      }else{
        this.startToMove = false
        this.oldLeft = null
        this.oldTop = null
        if(this.left < (this.clientW / 2)) {
            this.left = 0
            this.handleIconY()
        } else {
            this.left = this.clientW - this.itemWidth
            this.handleIconY()
        }
        this.$refs.dragIcon.style.transition = "all .3s"
      }
    },
    handleIconY() {
      if (this.top < 0) {
          this.top = 0
      } else if(this.top + this.itemHeight > this.clientH) {
          this.top = this.clientH - this.itemHeight
      }
    },
    bindScrollEvent() {
      window.addEventListener('scroll', this.handleScrollStart)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll',this.handleScrollStart)
    },
    handleScrollStart() {
      this.isShow = false
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
          this.handleScrollEnd()
      },300)
      this.currentTop = document.documentElement.scrollTop || document.body.scrollTop
    },
    handleScrollEnd() {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 判断是否停止滚动的条件
      if(this.scrollTop == this.currentTop) {
          this.isShow = true
      }
    }
  }
}
</script>
<style lang="scss">
.dragIcon {
  position: fixed;
  right: 0;
  bottom: 70px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba($color: #edf4ff, $alpha: 0.7);
  line-height: 40px;
  text-align: center;
  color: #fff;
  z-index: 999;
  cursor: pointer;
  border: 1px solid #bdd1ec;
  i{
    font-size: 24px;
    color: #262628;
    line-height: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/courseware/dragIcon.vue